/* ADMIN CHANGE HISTORY FILTER OPTIONS */
export const GET_ADMIN_CHANGE_HISTORY_FILTERS = "GET_ADMIN_CHANGE_HISTORY_FILTERS"
export const GET_ADMIN_CHANGE_HISTORY_FILTER_SUCCESS = "GET_ADMIN_CHANGE_HISTORY_FILTER_SUCCESS"
export const GET_ADMIN_CHANGE_HISTORY_FILTER_ERROR = "GET_ADMIN_CHANGE_HISTORY_FILTER_ERROR"
